import { Space, SpaceVertical, type SpaceVerticalProps } from '@looker/components';
import { DsRadio, DsRadioGroup, DsTypography } from '@pulsepointinc/design-system-react';
import { type FC, useEffect, useId, useState } from 'react';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import { useFilters } from '../../../../../../hooks/useFilters';
import type { Filter } from '../../../../../../stores/filters';

interface YesNoToggleFiltersProps extends ICustomFilter, SpaceVerticalProps {
  onMultiFilterChange?: (filter: Filter) => void;
  filterName: string;
}

export const YesNoToggleFilters: FC<YesNoToggleFiltersProps> = ({
  onMultiFilterChange,
  onChange,
  filterName,
  ...spaceProps
}) => {
  const radioGroupId = useId();
  const { filters } = useFilters();
  const filterExpression = filters[filterName]?.expression ?? '';

  const toggleOptions = ['Yes', 'No'];

  const [selectedOption, setSelectedOption] = useState('');

  const defaultFilter: Filter = {
    filterName,
    expression: selectedOption,
    enabled: true,
    expressionType: 'target',
  };

  useEffect(() => {
    if (onMultiFilterChange) {
      const filterToSend = filterExpression ? { ...defaultFilter, expression: filterExpression } : defaultFilter;

      onMultiFilterChange(filterToSend);
    }
  }, [filterExpression]);

  useEffect(() => {
    if (filterExpression) {
      setSelectedOption(filterExpression);
    }
  }, [filterExpression]);

  const handleRadioChange = (value: string) => {
    setSelectedOption(value);

    const filter: Filter = {
      filterName,
      expression: value,
      enabled: true,
      expressionType: defaultFilter.expressionType,
    };

    if (onMultiFilterChange) {
      onMultiFilterChange(filter);
    }
    if (onChange) {
      onChange(filter.expression);
    }
  };

  return (
    <SpaceVertical gap="u3" paddingX="u6" {...spaceProps}>
      <Space gap="u4" align="center">
        <DsTypography variant="label">Selection</DsTypography>

        <DsRadioGroup
          name={radioGroupId}
          orientation="horizontal"
          value={selectedOption}
          onValueChange={(e) => handleRadioChange(e.detail as string)}
        >
          {toggleOptions.map((option: string) => (
            <DsRadio key={option} name={radioGroupId} label={option} value={option} />
          ))}
        </DsRadioGroup>
      </Space>
    </SpaceVertical>
  );
};

export default YesNoToggleFilters;
